<template>
  <CommonForm :strategyList="strategyList">
    <el-col :span="7" class="col-h">
		<el-form-item label="出价" prop="price" :rules="moneyRules">
			<el-input 
				v-model="formData.price" placeholder="请输入价格 元/千次"
				@input="(value)=>handleInput('price', value)"
			/>
		</el-form-item>
		<div class="form-item__tip" v-if="priceAvg">
			<TipInfo :data="priceAvg"/>
		</div>
	</el-col>
  </CommonForm>
</template>

<script>
import CommonForm from './commonForm.vue'
import { validNum } from '@/utils/validate'
import { numStrip } from '@/utils'
import TipInfo from './tipInfo'
export default {
	name:'NonConversionForm',
	components: { CommonForm, TipInfo  },
	inject: [ 'global', 'formData' , 'moneyRules'],
	props: {
		strategyList: {
			type: Array,
			default: ()=> null
		}
	},
	data() { 
		return {
			priceAvg: '', // 出价均值
		}
	},
    methods: {
		handleInput(key, value) {
			if(!validNum(value)) {
				this.priceAvg = ''
				return 
			}
			const num = this.global.handleValidNumber(value);
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			if(!value) {
				this.priceAvg = '';
				return
			}
			const params = {
				price_type: this.formData.way,
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.price_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.price_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
    },
	watch: {
		'formData.way': {
			handler (n) {
				this.avgValue(this.formData.price);
			},
		}
	}
}
</script>

<style lang="scss" scoped>
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>